module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/allocation/allocation-reports/allocation-reports.component.css
// module id = ./src/app/allocation/allocation-reports/allocation-reports.component.css
// module chunks = main